import { render, staticRenderFns } from "./DocumentProductionHeader.vue?vue&type=template&id=450adf2a&scoped=true"
import script from "./DocumentProductionHeader.vue?vue&type=script&lang=js"
export * from "./DocumentProductionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450adf2a",
  null
  
)

export default component.exports